var Information = {
  init() {}
}

export default Information
